import { find } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Tag } from "../../App/components/atoms";
import { listenToLocation1688FromFirestore } from "../../App/firestore/firestoreService";
import { userFirestoreDoc } from "../../App/hooks/useFirestoreDoc";
import { AdminPage } from "../../App/layout/AdminPage/AdminPage";
import { listenToSelectedLocation1688 } from "../../App/redux/data/location1688/location1688Actions";

const currentMenu = (id: string) => [
  // appendRouteHere
  {
    key: "orders",
    label: "Orders",
    link: `/production-location/${id}/orders`,
  },

  {
    key: "returns",
    label: "Returns",
    link: `/production-location/${id}/returns`,
  },
  {
    key: "inventory",
    label: "Goods received",
    link: `/production-location/${id}/inventory`,
  },
  {
    key: "productions",
    label: "Productions",
    link: `/production-location/${id}/productions`,
  },
  {
    key: "baked-stock",
    label: "Baked Stock",
    link: `/production-location/${id}/baked-stocks`,
  },
  {
    key: "raw-stock",
    label: "Raw Stock",
    link: `/production-location/${id}/raw-stocks`,
  },
];
const currentBreadcrumb = (name: string) => [
  {
    key: "page",
    label: name,
    link: "#",
  },
];

const ProductionPage: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const [pageName, setPageName] = React.useState<string>("");
  const [breadcrumb, setBreadcrumb] = React.useState<any[]>([]);
  const productionLineId = params.productionLineId || "";
  const headerMenu = currentMenu(productionLineId);
  const { selectedLocation1688 } = useSelector(
    (state: any) => state.location1688
  );
  userFirestoreDoc({
    query: () => listenToLocation1688FromFirestore(productionLineId),
    data: listenToSelectedLocation1688,
    shouldExecute: !!productionLineId,
    deps: [dispatch, productionLineId],
  });

  React.useEffect(() => {
    const name = find(headerMenu, ["link", location.pathname]);
    setBreadcrumb(currentBreadcrumb(name?.label || "") || []);
    setPageName(name?.label || "");
  }, [location.pathname]);

  return (
    <AdminPage
      title={
        <div className="admin-page-title">
          {selectedLocation1688?.name} <Tag>{pageName}</Tag>
        </div>
      }
      headerMenu={headerMenu}
      breadcrumb={breadcrumb}
    >
      <Outlet />
    </AdminPage>
  );
};

export default ProductionPage;
